import { useEffect } from "react"
import { useTour } from "./TourContext"
import { TourTooltip } from "./TourTooltip"

export default function CoachTour() {
  const { isTourActive } = useTour()

  // Dismiss FeedbackWidget if open when tour starts
  useEffect(() => {
    if (isTourActive) {
      window.dispatchEvent(new CustomEvent("tour:start"))
    }
  }, [isTourActive])

  if (!isTourActive) return null

  return (
    <>
      {/* Full-screen dimmed backdrop */}
      <div
        aria-hidden="true"
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 60,
          backgroundColor: "rgba(0,0,0,0.65)",
          pointerEvents: "none",
        }}
      />

      {/* Centered page-description modal */}
      <TourTooltip />
    </>
  )
}
